{
  "CONTACT_TABLE": {
    "TABLE_HEADERS": {
      "NAME": "Name",
      "RECIPIENT_EMAIL": " Recipient Email",
      "CLICKS": "Clicks",
      "DATE_CLICKED": "Date Clicked"
    },
    "EMPTY_STATE": {
      "DESCRIPTION": "There is no link activity to display"
    },
    "DOWNLOAD_DIALOG": {
      "TITLE": "Download link activity",
      "DESCRIPTION": "This action will download the data that's been filtered on your screen.",
      "NOTIFICATION": "You'll receive a notification when the file is ready to download. You can access the file by clicking that notification.",
      "DOWNLOAD": "Download",
      "SUCCESS": "Generating CSV file. You will be notified when it is ready. \uD83D\uDD14",
      "ERROR": "There was a problem downloading data. Please try again."
    }
  },
  "EMAIL_STATS": {
    "CLICK_RATIO": "Click Ratio",
    "LINK_ACTIVITY": "Link Activity",
    "TOTAL_CLICKS": "Total Clicks",
    "UNIQUE_CLICKS": "Unique Clicks",
    "SEE_WHO_CLICKED": "See who clicked",
    "LINK_CLICK_RATE_TOOLTIP": "Percent of email recipients that clicked on this link."
  },
  "CAMPAIGNS": {
    "TITLE": "Campaigns",
    "BETA": "BETA",
    "NO_CAMPAIGNS": "No email campaigns have been started for this account",
    "CAMPAIGN_ACTIVE_TOOLTIP": "Campaign is active",
    "CAMPAIGN_PAUSED_TOOLTIP": "Campaign is paused",
    "CAMPAIGN_ENDED_TOOLTIP": "Campaign has ended",
    "CAMPAIGN_CREATING_TOOLTIP": "Campaign creation takes a moment. Please check back again later.",
    "FAILED_STATUS_UPDATE": "Failed to update status. Click to try again.",
    "CREATE_CAMPAIGN": "Create Campaign",
    "CAMPAIGN_NAME": "Campaign Name",
    "NAME": {
      "CREATE": "Enter a name to create a campaign",
      "UPDATE_SUCCESS": "Campaign name updated",
      "UPDATE_FAILURE": "The campaign name failed to update. Please try again.",
      "TOO_LONG": "The campaign name can't exceed 100 characters",
      "TOO_SHORT": "Your campaign needs to be named"
    },
    "CONTACTS": {
      "SELECT_CAMPAIGN_RECIPIENTS": "Select campaign recipients",
      "MODAL": {
        "SELECT_ALL_SUCCESS": "{{ totalObjects }} contacts added to campaign: {{ campaignTitle }}",
        "ID": "ID",
        "NAME": "Name",
        "EMAIL": "Email",
        "NO_CONTACTS": "No contacts found",
        "NEXT": "Next",
        "BACK": "Back",
        "SCHEDULE_OR_START": "Schedule or start campaign",
        "SEND_NOW": "Now",
        "SEND_TIME": "Campaign will start for the selected recipients on",
        "SCHEDULE_LATER": "Later",
        "SCHEDULE_LATER_LABEL": "Campaign will start for the selected recipients at a scheduled time",
        "PICK_DATE": "Pick a date",
        "PICK_TIME": "Pick a time",
        "START_CAMPAIGN": "Start campaign",
        "CANCEL": "Cancel",
        "NUM_RECIPIENTS": "Recipients selected ( Max 20 )",
        "ERRORS": {
          "GENERIC_ERROR": "There was a problem starting the campaign. Please try again.",
          "SELECT_DATE": "Please select a date.",
          "SELECT_TIME": "Please select a time.",
          "SELECT_CONTACTS": "Please select at least one contact.",
          "MAX_CONTACTS": "You can only select up to 20 contacts.",
          "FAILED_ADDRESS_ERROR": "Failed to add the following addresses: ",
          "FAILED_CONTACT_ERROR": "Failed to add 1 contact. Please ensure that the selected recipient has the required information for each step in the campaign.",
          "FAILED_CONTACTS_COUNT_ERROR": "Failed to add {{ count }} contacts. Please ensure that the selected recipients have the required information for each step in the campaign.",
          "FAILED_CAMPAIGN_ALERT_TITLE": "Some contacts cannot be added to this campaign",
          "FAILED_CAMPAIGN_ALERT_MESSAGE": "Some contacts cannot be added to this campaign. Please try again.",
          "FAILED_ADDRESS_ERROR_EMAIL": "Contacts must have an email address to receive campaigns with email steps.",
          "FAILED_ADDRESS_ERROR_SMS": "Contacts must have a phone number to receive campaigns with SMS steps."
        },
        "SUCCESS": "Success"
      }
    }
  },
  "CAMPAIGN_GENERIC": {
    "TEST_EMAIL": {
      "TITLE": "Preview of {{ name }}",
      "SUBJECT": "Subject:",
      "COUNT": "Event {{ curr }} of {{ total }}",
      "NO_EVENTS": "No events to preview.",
      "SEND_EMAIL": "Send test email",
      "SEND_TEST_EMAIL_TO_MYSELF": "Send test email to myself",
      "SEND_TEST_LABEL": "Send emails to (space or comma separated, up to 5 entries)",
      "SEND_TEST_PLACEHOLDER": "user@example.com admin@example.com",
      "SEND_TEST_HINT": "To preview this email as a specific account, return to the main campaign page.",
      "SUCCESS": "Test email sent.",
      "FAILURE": "There was a problem sending the test email: {{ message }}",
      "PREVIEW_AS": "Preview email as",
      "GENERIC_ACCOUNT": "Generic account"
    }
  },
  "TABLE": {
    "COLUMNS": {
      "TAGS": {
        "ADD_TAG_BUTTON_TEXT": "Add tag"
      }
    }
  },
  "MANAGE_TAGS": {
    "MANAGE_TAGS": "Manage Tags",
    "NEW_TAG": "New Tag",
    "CLOSE": "Close",
    "ADD_NEW": "Add New Tag",
    "NAME_OF_NEW_TAG": "Name of New Tag",
    "CANCEL": "Cancel",
    "TAG_ADD_SUCCESS": "Tag added",
    "TAG_ADD_FAILURE": "Failed to add tag",
    "TAG_CREATE_SUCCESS": "Tag created",
    "TAG_CREATE_FAILURE": "Failed to create new tag",
    "SAVE": "Save",
    "TAG_NAME": "Tag name",
    "SEARCH_FOR_TAG": "Search for a tag",
    "BACK_COMPAT_POPOVER_HINT": "Read only",
    "TAG_DELETE_SUCCESS": "Tag deleted",
    "TAG_DELETE_FAILURE": "Failed to delete tag"
  },
  "COMMON": {
    "ACTION_LABELS": {
      "VIEW_MORE": "View more",
      "VIEW_LESS": "View less",
      "PAUSE": "Pause",
      "RESUME": "Resume",
      "NA": "N/A",
      "ACTIONS": "Actions",
      "PUBLISH": "Publish",
      "UNPUBLISH": "Unpublish",
      "ADD_EMAIL": "Add email",
      "COPY": "Copy",
      "ARCHIVE": "Archive",
      "DELETE": "Delete",
      "ADD_ACCOUNT_LIST_TO_CAMPAIGN": "Add account list to campaign",
      "CREATE": "Create",
      "CANCEL": "Cancel",
      "ADD_RECIPIENTS": "Add recipients",
      "VIEW_HISTORY": "View history",
      "LEAVE": "Leave"
    }
  },
  "PREVIEW": {
    "ACTION": "Preview",
    "PREVIOUS": "Previous",
    "COUNT": "Event {{ curr }} of {{ total }}",
    "NEXT": "Next"
  },
  "CAMPAIGN_STATUS": {
    "PAUSED": "Paused",
    "DRAFT": "Draft",
    "PUBLISHED": "Published",
    "ARCHIVED": "Archived",
    "ONGOING": "Ongoing",
    "COMPLETED": "Completed"
  },
  "CAMPAIGN_FOCUS": {
    "ACQUIRE": "Acquire campaign",
    "ADOPT": "Adoption campaign",
    "UPSELL": "Upsell campaign",
    "UPDATE_SUCCESS": "Campaign focus updated",
    "UPDATE_FAILURE": "The campaign focus wasn't updated. Please try again"
  },
  "EMAIL_LIBRARY": {
    "TITLE": "Emails",
    "ADD_EMAILS": "Add emails",
    "FEATURED_TEMPLATES": "Featured templates",
    "MY_TEMPLATES": "My templates",
    "CARD": {
      "CREATED": "Created",
      "UPDATED": "Updated"
    },
    "NO_RESULTS": "No results found",
    "SEARCH_PLACEHOLDER": "Search for an email",
    "TOTAL_RESULTS_PLURAL": "{{ totalResults }} emails",
    "TOTAL_RESULTS_SINGULAR": "{{ totalResults }} email"
  },
  "CAMPAIGN_DETAILS": {
    "TITLE": "Campaign Details",
    "DRAFT_MODE": "Draft mode",
    "DRAFT_WARNING": "You're editing a draft of this campaign. When you're ready to start using it, click 'Publish'.",
    "ADD_EMAIL": "Add Email",
    "TEMPLATE": {
      "CREATE_NEW": "Add new email",
      "ADD_EXISTING": "Add existing email",
      "ADD_SMS": "Add SMS",
      "ADD_SNAPSHOT_REPORT": "Add snapshot report",
      "EDIT_SMS": "Edit SMS"
    },
    "ACTIONS": {
      "COPY": "Copy",
      "ARCHIVE_SUCCESS": "Campaign archived",
      "ARCHIVE_FAILURE": "Failed to archive campaign",
      "COPY_DIALOG": {
        "PLEASE_WAIT": "Please wait while a copy of this campaign is created...",
        "LONG_WAIT": "This is taking longer than usual, but the duplication is still running. Please wait...",
        "ERROR": "There was a problem making a copy of the campaign.",
        "TRY_AGAIN": "Try Again"
      },
      "COPY_DIALOG_SUCCESS": {
        "SUCCESS_TITLE": "Campaign copied",
        "OPEN_COPIED_CAMPAIGN": "Would you like to open the copied campaign?",
        "OPEN_BUTTON": "Go to copied campaign",
        "CLOSE": "Close"
      }
    },
    "UPDATE": {
      "SUCCESS": "Updated campaign",
      "FAILURE": "We couldn't update the campaign. Please try again.",
      "ERROR": "Add one or more steps to the campaign"
    },
    "CONFIRMATION_DIALOG": {
      "ARCHIVE": {
        "TITLE": "Archive {{ title }}?",
        "MESSAGE": "You won't be able to use or edit this campaign, and you can't undo this action. The recipients who have been added to this campaign will still receive the remaining emails.",
        "CONFIRM": "Archive campaign",
        "DECLINE": "Cancel"
      },
      "DELETE_STEP": {
        "EVENT": {
          "TITLE": "Delete {{ name }} event?",
          "MESSAGE": "Are you sure you want to delete the \"{{ name }}\" event? This action can't be undone."
        },
        "CONFIRM": "Delete event",
        "DECLINE": "Keep event"
      },
      "EDIT": {
        "TITLE": "Unsaved Changes",
        "MESSAGE": "You have unsaved changes. Are you sure you want to leave this page?"
      }
    },
    "STEP": {
      "DAY": "Day",
      "DELAY": "Delay",
      "WAIT": "Wait",
      "PREVIOUS_EVENT": "after previous event",
      "FIRST_EVENT": "before starting",
      "SUBJECT": "Subject:",
      "CONTENT": "Content:",
      "EDIT": "Edit email",
      "EDIT_SMS": "Edit SMS",
      "PREVIEW": "Preview",
      "SMS_PREVIEW": "SMS Preview",
      "EMAIL_PREVIEW": "Email Preview",
      "EMAIL_PREVIEW_ERRORS": "We couldn't update the preview due to the following errors:",
      "EMAIL_PERFORMANCE": "Email Performance",
      "SMS_PERFORMANCE": "SMS Performance",
      "MORE_ACTIONS": "More actions",
      "DETAILS": "Details",
      "DELETE": "Delete",
      "NAME": "Name:",
      "MAKE_A_COPY": "Make a copy",
      "VIEW_EMAIL_ACTIVITY": "View email activity",
      "RENDERING_FAKE_DATA": "This preview contains some placeholder content"
    },
    "PAUSE": {
      "ACTION": "Pause",
      "TITLE": "Pause {{ title }}?",
      "MESSAGE": "Scheduled campaign events will be paused for all recipients currently on this campaign. This action may take a few minutes to complete.",
      "CONFIRM": "Pause campaign",
      "DECLINE": "Cancel",
      "SUCCESS": "Campaign paused",
      "FAILURE": "There was a problem pausing the campaign. Refresh the page and try again."
    },
    "RESUME": {
      "ACTION": "Resume",
      "TITLE": "Resume {{ title }} for paused recipients?",
      "MESSAGE": "The campaign will resume as scheduled, and the recipients in the 'Stopped' state will move to 'In progress'. Recipients won’t receive emails they’ve already received, and delays before scheduled events will restart. This action may take a few minutes to complete.",
      "CONFIRM": "Resume campaign",
      "DECLINE": "Cancel",
      "SUCCESS": "Campaign resumed",
      "FAILURE": "There was a problem resuming the campaign. Refresh the page and try again."
    },
    "DELETE": {
      "TITLE": "Delete draft?",
      "MESSAGE": "This campaign will be permanently deleted.",
      "ACTION": "Delete"
    },
    "EMPTY_STATE": {
      "TITLE": "Add steps to your campaign",
      "DESCRIPTION_1": "You can add a single step, or multiple steps with delays in between sending.",
      "DESCRIPTION_2": "Once you’re done, publish your campaign to start adding recipients."
    }
  },
  "CAMPAIGN_OPTIONS": {
    "DAYS": {
      "MONDAY": "Mon",
      "TUESDAY": "Tue",
      "WEDNESDAY": "Wed",
      "THURSDAY": "Thu",
      "FRIDAY": "Fri",
      "SATURDAY": "Sat",
      "SUNDAY": "Sun"
    },
    "CONFIG": {
      "TITLE": "Campaign configuration",
      "SUBTITLE": "Configure sending days and timezone",
      "SUCCESS": "Campaign scheduling saved",
      "FAILURE": "There was an error saving the campaign scheduling. Please try again.",
      "TIMEZONE_FAILURE": "Select a valid timezone from the scheduling dropdown."
    },
    "SCHEDULING": {
      "TITLE": "Scheduling",
      "TIME_ZONE": {
        "DESCRIPTION": "Select 'campaign sent' time zone",
        "HINT": "This setting affects the time that your content will be sent"
      },
      "INCLUDED_DAYS": {
        "TITLE": "Included days",
        "WARNING": "No days selected, campaign will not be sent out",
        "HINT": "Emails will only be sent on the selected days above.\nNote: If a timed campaign event lands on a day that isn’t included, it will be sent on the next included day."
      }
    }
  },
  "EMAIL_EDITOR_PREVIEW": {
    "DESKTOP": "Desktop",
    "TABLET": "Tablet",
    "MOBILE": "Mobile",
    "CREATE_NEW": "Create new email",
    "ADD_EXISTING": "Add existing email"
  },
  "CAMPAIGN_PREVIEW": {
    "SEND_SUCCESS": "Preview email sent successfully",
    "SEND_FAILED": "Failed to send preview email. Try selecting another contact.",
    "NONE_SELECTED": "Select campaign to view a preview",
    "LOOKUP_FAILED": "Unable to render email preview. Try refreshing the page or selecting a different campaign"
  },
  "STATS": {
    "QUEUED": "Queued",
    "FAILED": "Failed",
    "SENT": "Sent",
    "UNDELIVERED": "Undelivered",
    "DELIVERED": "Delivered",
    "PENDING": "Pending",
    "OPEN_RATE": "Open rate",
    "CLICK_RATE": "Click rate",
    "OPENED": "Opened",
    "CLICKS": "Clicks",
    "DELIVERY_STATUS": "Delivery status",
    "BOUNCED": "Bounced",
    "DROPPED": "Dropped",
    "UNSUBSCRIBED": "Unsubscribed",
    "SPAM": "Spam",
    "SMS": {
      "QUEUED_TOOLTIP_SINGLE": "1 sms is queued for delivery within the specified date range",
      "QUEUED_TOOLTIP": "{{ queued }} SMSs are queued for delivery within the specified date range",
      "SENT_TOOLTIP_SINGLE": "1 sms was sent within the specified date range",
      "SENT_TOOLTIP": "{{ sent }} SMSs sent within the specified date range",
      "FAILED_TOOLTIP_SINGLE": "1 sms failed within the specified date range",
      "FAILED_TOOLTIP": "{{ failed }} SMSs failed within the specified date range",
      "UNDELIVERED_TOOLTIP_SINGLE": "1 sms was undelivered within the specified date range",
      "UNDELIVERED_TOOLTIP": "{{ undelivered }} SMSs undelivered within the specified date range"
    },
    "EMAIL": {
      "DELIVERED_TOOLTIP_SINGLE": "1 email has been delivered within the specified date range",
      "DELIVERED_TOOLTIP": "{{ delivered }} emails have been delivered within the specified date range",
      "PENDING_TOOLTIP_SINGLE": "1 email is pending delivery within the specified date range",
      "PENDING_TOOLTIP": "{{ pending }} emails are pending delivery within the specified date range",
      "OPEN_RATE_TOOLTIP_SINGLE": "1 email has been opened within the specified date range",
      "OPEN_RATE_TOOLTIP": "{{ openRate }}% of emails have been opened within the specified date range",
      "CLICK_RATE_TOOLTIP_SINGLE": "1 email has been clicked within the specified date range",
      "CLICK_RATE_TOOLTIP": "{{ clickRate }}% of emails have been clicked within the specified date range",
      "OPEN_TOOLTIP_SINGLE": "1 email has been opened within the specified date range",
      "OPEN_TOOLTIP": "{{ opens }} emails have been opened within the specified date range",
      "CLICK_TOOLTIP_SINGLE": "1 email has been clicked within the specified date range",
      "CLICK_TOOLTIP": "{{ clicks }} emails have been clicked within the specified date range",
      "BOUNCED_TOOLTIP_SINGLE": "1 email has bounced within the specified date range",
      "BOUNCED_TOOLTIP": "{{ bounces }} emails have bounced within the specified date range",
      "DROPPED_TOOLTIP_SINGLE": "1 email has been dropped within the specified date range",
      "DROPPED_TOOLTIP": "{{ drops }} emails have been dropped within the specified date range",
      "UNSUBSCRIBED_TOOLTIP_SINGLE": "1 email has been unsubscribed within the specified date range",
      "UNSUBSCRIBED_TOOLTIP": "{{ unsubscribes }} emails have been unsubscribed within the specified date range",
      "SPAM_TOOLTIP_SINGLE": "1 email has been marked as spam within the specified date range",
      "SPAM_TOOLTIP": "{{ spamReport }} emails have been marked as spam within the specified date range"
    },
    "RECIPIENT_STATS": {
      "TITLE": "Campaign status by recipient",
      "RECIPIENTS": "Recipients",
      "RECIPIENTS_TOOLTIP_SINGLE": "1 email recipient has received an email in this campaign within the specified date range",
      "RECIPIENTS_TOOLTIP": "{{ recipients }} email recipients have received an email in this campaign within the specified date range",
      "BUFFERING": "Buffering",
      "BUFFERING_TOOLTIP_SINGLE": "1 recipient hasn’t received the first email in this campaign yet, due to the specified daily limit. This number is not applicable when selecting a specific date range.",
      "BUFFERING_TOOLTIP": "{{ buffering }} recipients haven’t received the first email in this campaign yet, due to the specified daily limit. This number is not applicable when selecting a specific date range.",
      "IN_PROGRESS": "In progress",
      "IN_PROGRESS_TOOLTIP_SINGLE": "1 recipient has started but not completed this campaign. This number is not applicable when selecting a specific date range.",
      "IN_PROGRESS_TOOLTIP": "{{ inProgress }} recipients have started but not completed this campaign. This number is not applicable when selecting a specific date range.",
      "STOPPED": "Stopped",
      "STOPPED_TOOLTIP_SINGLE": "1 recipient has been paused or stopped before completing this campaign. This number is not applicable when selecting a specific date range.",
      "STOPPED_TOOLTIP": "{{ stopped }} recipients have been paused or stopped before completing this campaign. This number is not applicable when selecting a specific date range.",
      "COMPLETED": "Completed",
      "COMPLETED_TOOLTIP_SINGLE": "1 recipient has received all the emails in this campaign. This number is not applicable when selecting a specific date range.",
      "COMPLETED_TOOLTIP": "{{ completed }} recipients have received all the emails in this campaign. This number is not applicable when selecting a specific date range."
    },
    "PERFORMANCE_STATS": {
      "TITLE": "Campaign Performance",
      "TOTAL_LEADS": "Engaged Recipients",
      "TOTAL_LEADS_TOOLTIP_SINGLE": "1 account opened an email in this campaign.",
      "TOTAL_LEADS_TOOLTIP": "{{ totalLeads }} accounts opened an email this campaign.",
      "DELIVERY_RATE": "Delivery rate",
      "DELIVERY_RATE_TOOLTIP_SINGLE": "1 of the sent emails was delivered to accounts.",
      "DELIVERY_RATE_TOOLTIP": "{{ delivered }} of the sent emails were delivered to accounts.",
      "OPEN_RATE": "Open rate",
      "OPEN_RATE_TOOLTIP_SINGLE": "1 of the delivered emails was opened.",
      "OPEN_RATE_TOOLTIP": "{{ opened }} of the delivered emails were opened.",
      "CTOR": "CTOR",
      "CLICKED_TOOLTIP_SINGLE": "1 email was clicked through by accounts on this campaign.",
      "CLICKED_TOOLTIP": "{{ clickedThrough }} emails were clicked through by accounts on this campaign.",
      "CLICKED_THROUGH_TOOLTIP_SINGLE": "Click-to-open rate. 1 of the opened emails was clicked through.",
      "CLICKED_THROUGH_TOOLTIP": "Click-to-open rate. {{ clickedThrough }} of the opened emails were clicked through.",
      "UNDELIVERABLE": "Undeliverable",
      "UNDELIVERABLE_TOOLTIP_SINGLE": "1 of the sent emails could not be delivered to accounts.",
      "UNDELIVERABLE_TOOLTIP": "{{ undeliverable }} of the sent emails could not be delivered to accounts."
    }
  },
  "STEP": {
    "DAY": "Day",
    "DELAY": "Delay",
    "WAIT": "Wait",
    "PREVIOUS_EVENT": "after previous event",
    "FIRST_EVENT": "before starting",
    "SUBJECT": "Subject:",
    "CONTENT": "Content:",
    "EDIT": "Edit email",
    "PREVIEW": "Preview",
    "EMAIL_PREVIEW": "Email Preview",
    "EMAIL_PREVIEW_ERRORS": "We couldn't update the preview due to the following errors:",
    "EMAIL_PERFORMANCE": "Email Performance",
    "MORE_ACTIONS": "More actions",
    "DETAILS": "Details",
    "DELETE": "Delete",
    "MAKE_A_COPY": "Make a copy",
    "VIEW_EMAIL_ACTIVITY": "View email activity",
    "RENDERING_FAKE_DATA": "This preview contains some placeholder content"
  },
  "EMAIL_BUILDER": {
    "PAGE": {
      "ACTIONS": {
        "SEND_PREVIEW_EMAIL": "Send preview email",
        "SAVE": "Save",
        "SAVE_SUCCESS": "Saved successfully",
        "ERROR_NOTICE": "There was a problem saving the campaign step"
      },
      "TITLE": "Edit email",
      "PREVIOUS_PAGE_TOOLTIP": "Back to Campaign Details",
      "HANDLE_RENDER_ERROR": "There is an error with one or more of the dynamic components. Please check for incorrect spelling or added/missing characters."
    }
  },
  "SMS_BUILDER": {
    "PAGE": {
      "TITLE": "Edit SMS"
    }
  },
  "CAMPAIGN_ACTIVITY": {
    "TITLE": "Campaign Activity",
    "TABLE": {
      "HEADERS": {
        "RECIPIENT": "Recipient",
        "STEP_NAME": "Event",
        "EVENT_TYPE": "Activity",
        "DATE": "Date"
      },
      "EMPTY": "No activity yet",
      "FILTERS": {
        "TITLE": "Filters",
        "EVENT": "Event",
        "EVENT_PLACEHOLDER": "Select Event",
        "EMAIL_ACTIVITY": "Email Activity",
        "PROCESSED": "Processed",
        "DELIVERED": "Delivered",
        "OPENED": "Opened",
        "CLICKED_THROUGH": "Clicked Through",
        "BOUNCED": "Bounced",
        "SPAM_REPORT": "Spam Report",
        "UNSUBSCRIBE": "Unsubscribe",
        "DROPPED": "Dropped"
      }
    }
  },
  "QUOTA_BANNER": {
    "USAGE": {
      "BANNER_TITLE": "Marketing emails sent this billing period",
      "SMS_BANNER_TITLE": "Marketing SMS sent this billing period",
      "BANNER_CTA": "Upgrade",
      "BANNER_OF": "{{usage}} of {{quota}}"
    }
  },
  "SMS": {
    "TITLE": "SMS messages",
    "SUBTITLE": "Available as add ons",
    "DESCRIPTION": "Increase customer engagement with your marketing.",
    "DESCRIPTION_2": "Send personalized SMS messages through campaigns to keep customers engaged and further drive sales",
    "PURCHASE": "Purchase add-on"
  },
  "CAMPAIGN_PREVIEW_MODAL": {
    "TITLE": "Send campaign",
    "PREVIEWING_AS": "Previewing as:",
    "SELECT_ACTION": "Change",
    "SEND": "Send",
    "SEND_NOW": "Send now",
    "SEND_NOW_TOOLTIP": "Using send now will begin the campaign(s) immediately and will disregard the campaign configuration.  ",
    "SCHEDULE_SEND": "Schedule",
    "CANCEL": "Cancel",
    "CAMPAIGN_LABEL": "Campaign",
    "SEND_TO": "Send to",
    "SEND_FROM": "Send from",
    "SEARCH_CAMPAIGNS": "Search campaigns...",
    "SELECTED_RECIPIENTS": "{{selected}} recipients selected",
    "SELECT_RECIPIENTS": "Select recipients",
    "SEARCH_CONTACTS": "Search contacts",
    "SHOW_LESS": "Show less",
    "SHOW_MORE": "+ {{ recipient_count }} more",
    "SELECTED_RECIPIENT_SINGLE": "1 recipient selected",
    "ESTIMATED_RECIPIENTS": "Estimated recipients: {{estimated}}/{{total}}",
    "SELECT_ALL_ESTIMATED_RECIPIENTS": "Estimated recipients: {{estimated}}",
    "ESTIMATED_RECIPIENTS_INFO": "This is the total number of contacts that have the required information for each step in a campaign: email addresses for email steps and phone numbers for SMS steps.",
    "DEFAULT_EMAIL_SETTINGS": "Default email",
    "REQUIRED_FIELD": "This field is required",
    "SENDER_OPTIONS": {
      "DEFAULT": "Default email",
      "CUSTOM": "Custom email",
      "SALESPERSON": "Assigned salesperson"
    },
    "EMAIL_SETTINGS": {
      "EMAIL_SETTINGS": "Email settings",
      "SENDER_NAME": "Sender name",
      "SENDER_NAME_HINT": "This is the from name recipients will see in their inbox",
      "SENDER_ADDRESS": "Sender address",
      "SENDER_ADDRESS_HINT": "This is the address recipients will see the email coming from ",
      "REPLY_ADDRESS": "Reply address",
      "REPLY_ADDRESS_HINT": "This is where emails will be sent to if a recipient replies"
    },
    "ASSIGNED_SALESPERSON": {
      "TITLE": "Emails using unauthenticated domains are subject to change",
      "DESCRIPTION": "Salespeople email addresses that do not use an authenticated domain will be changed to use the verified domain (eg. yourname@mail.com will become \u2028yourname-mail.com@verifieddomain.com).",
      "DESCRIPTION_2": "Replies will go to the unverified email."
    },
    "YOUR_ASSIGNED_SALESPERSON": "Your assigned salesperson",
    "SUCCESS": "{{ count }} recipients added to campaign: {{ campaignTitle }}",

    "CONTACT_MODAl": {
      "HINT": "Contact",
      "TITLE": "Select contact",
      "CANCEL": "Cancel"
    },
    "TABS": {
      "SENDING_OPTIONS": "Sending options",
      "PREVIEW": "Preview"
    },
    "ERRORS": {
      "MAX_DATE_EXCEEDED_ERROR": "Cannot exceed 30 days"
    }
  }
}
